import { FaWhatsapp } from 'react-icons/fa6';
import styles from './WhatsAppButton.module.css';

const WA_LINK = 'https://wa.me/5548988393447?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20SteinSoft.';

export default function WhatsAppButton() {
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.button}
      aria-label="Fale conosco pelo WhatsApp"
    >
      <FaWhatsapp className={styles.icon} />
    </a>
  );
}
